export default "__VITE_ASSET__$bv2S0Vi__";